import api from '@/api/api.js'

export default {
    getInfoSFE(data){
        const promise = api.comptabilite().post('/sfe/info_sfe', data)
        return promise.then(response => response.data)
    },

    getConfigInfoClinique(data){
        const promise = api.clinique().get('/config/info_clinique/'+data)
        return promise.then(response => response.data)
    },

    saveCustomExclusion(data) {
        const promise = api.comptabilite().post('/custom-exclusions/store', data)
        return promise.then((response) => response.data)
    },

    selectCustomExclusions() {
        const promise = api.comptabilite().get('/custom-exclusions/liste')
        return promise.then((response) => response.data)
    },
}